<div class="project-register-page">

  <div class="page-intro">
    <b3-breadcrumbs aria-label="Breadcrumb">
      <b3-breadcrumbs-item variant="icon" href="/consulta-projeto"></b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Registro de projetos e emissão de créditos</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Projeto de Crédito</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Registro</b3-breadcrumbs-item>
    </b3-breadcrumbs>
    <h1 class="page-title">Registro</h1>
  </div>

  <p *ngIf="isFinalizing" class="project-register-finalizing" aria-live="polite">
    Enviando projeto...
  </p>

  <form class="wizard-layout" [formGroup]="formRegister">
    <aside class="wizard-stepper" aria-label="Etapas do registro">
      <div class="wizard-stepper__header">
        <h2 class="wizard-stepper__title">Etapas</h2>
        <span class="wizard-stepper__progress">{{ stepProgress }}</span>
      </div>
      <div class="wizard-stepper__divider" aria-hidden="true"></div>
      <ol class="wizard-steps-list" aria-label="Progresso das etapas">
        <li
          *ngFor="let step of wizardStepsDisplay; let i = index"
          class="wizard-steps-list__item"
          [class.wizard-steps-list__item--active]="i === currentStep"
          [class.wizard-steps-list__item--completed]="i < currentStep"
          [class.wizard-steps-list__item--upcoming]="i > currentStep">
          <button
            type="button"
            class="wizard-steps-list__button"
            [disabled]="i > currentStep"
            (click)="onStepSelected(i)">
            <span class="wizard-steps-list__indicator" aria-hidden="true">
              <span *ngIf="i < currentStep" class="wizard-steps-list__check-mark">✓</span>
              <span *ngIf="i >= currentStep">{{ i + 1 }}</span>
            </span>
            <span class="wizard-steps-list__content">
              <span class="wizard-steps-list__title">{{ step.title }}</span>
              <span class="wizard-steps-list__description">{{ step.description }}</span>
            </span>
          </button>
        </li>
      </ol>
    </aside>

    <div class="wizard-content">
      <div class="wizard-content__panel">
        <h2 class="wizard-content__step-title">{{ currentStepTitle }}</h2>
        <div class="wizard-content__divider" aria-hidden="true"></div>

        <div class="wizard-content__body">
          <ng-container *ngFor="let _ of [stepContentVersion]; trackBy: trackByIndex">
            <ng-container
              *ngComponentOutlet="steps[currentStep].content; injector: steps[currentStep].injector">
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div class="wizard-actions" [class.wizard-actions--confirmation]="isConfirmationStep">
        <b3-button
          *ngIf="isConfirmationStep"
          type="button"
          class="wizard-actions__save"
          variant="outlined"
          tone="default"
          size="md"
          [disabled]="isSavingDraft"
          (b3-click)="saveDraft()">
          <b3-icon name="save" size="sm"></b3-icon>
          Salvar Rascunho
        </b3-button>

        <span class="wizard-actions__progress" aria-live="polite">{{ stepProgress }}</span>
        <div class="wizard-actions__buttons">
          <b3-button
            type="button"
            class="wizard-actions__back"
            variant="outlined"
            tone="default"
            size="md"
            [disabled]="currentStep === 0"
            (b3-click)="previousStep()">
            <b3-icon name="chevron_left" size="sm"></b3-icon>
            Voltar
          </b3-button>
          <b3-button
            type="button"
            class="wizard-actions__next"
            variant="filled"
            tone="default"
            size="md"
            *ngIf="!isConfirmationStep"
            [disabled]="enforceStepValidation && !canAdvance"
            (b3-click)="onAdvanceClick()">
            Avançar
            <b3-icon name="chevron_right" size="sm"></b3-icon>
          </b3-button>
          <b3-button
            type="button"
            class="wizard-actions__finish"
            variant="filled"
            tone="default"
            size="md"
            *ngIf="isConfirmationStep"
            [disabled]="isFinalizing || idProject <= 0"
            (b3-click)="finalizeProject()">
            <b3-icon name="check_circle" size="sm" tone="on-brand"></b3-icon>
            Finalizar
          </b3-button>
        </div>
      </div>
    </div>
  </form>

  <footer class="page-footer">
    B3SA© 2026 Plataforma de Carbono. Todos os direitos reservados.
  </footer>
</div>

<app-modal-project-register-submit
  *ngIf="isSubmitConfirmOpen"
  [open]="true"
  (closed)="onSubmitConfirmModalClosed($event)">
</app-modal-project-register-submit>

<app-modal-project-register-feedback
  *ngIf="isFeedbackModalOpen"
  [open]="true"
  [feedback]="pageFeedback"
  (closed)="onFeedbackModalClosed($event)">
</app-modal-project-register-feedback>

